import * as api from "./Resources.api";
import * as queries from "./Resources.queries";
import * as mutations from "./Resources.mutations";

export default { ...api, ...queries, ...mutations };
